import JsBarcode from "jsbarcode";

export function printBarCodeF({
  title = "",
  invNumber = "",
  invText = "",
  assetName = ""
}) {

  const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8" />
          <title>${title}</title>
          <style>
            @page {
              size: 4cm 2cm;
              margin: 0;
            }

            html, body {
              width: 4cm;
              height: 2cm;
              margin: 0;
              padding: 0;
            }

            body {
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: Arial, sans-serif;
              text-align: center;
            }

            .label {
              width: 4cm;
              height: 2cm;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }

            .inv {
              font-size: 8px;
              font-weight: bold;
              margin-bottom: 3px;
              line-height: 1;
              white-space: nowrap;
            }

            svg {
              width: 100%;
              max-height: 22px;
            }

            .name {
              font-size: 8px;
              margin-top: 3px;
              line-height: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          </style>
        </head>

        <body>
          <div class="label">
            <div class="inv">${invText}: ${invNumber}</div>
            <svg id="barcode"></svg>
            <div class="name">${assetName}</div>
          </div>
        </body>
        </html>
        `

      const iframe = document.createElement("iframe")
      iframe.style.position = "fixed"
      iframe.style.right = "0"
      iframe.style.bottom = "0"
      iframe.style.width = "0"
      iframe.style.height = "0"
      iframe.style.border = "0"

      document.body.appendChild(iframe)

      const doc = iframe.contentWindow.document
      doc.open()
      doc.write(html)
      doc.close()

      iframe.onload = () => {
        const win = iframe.contentWindow

        JsBarcode(
          win.document.getElementById("barcode"),
          String(invNumber),
          {
            format: "CODE128",
            displayValue: false,
            height: 30,
            margin: 0
          }
        )

        win.focus()
        win.print()
      }

      iframe.contentWindow.onafterprint = () => {
        document.body.removeChild(iframe)
      }
}
